import {Capacitor,registerPlugin} from '@capacitor/core';
import {signInWithCustomToken,signOut,Auth,User} from 'firebase/auth';
const buildApiUrl=(path:string)=>(process.env.REACT_APP_API_BASE_URL||'https://us-central1-finflowtechs.cloudfunctions.net/api').replace(/\/$/,'')+path;
const vault=registerPlugin<{status():Promise<{enrolled:boolean;uid?:string}>;enroll(value:{uid:string;refreshToken:string}):Promise<void>;restore():Promise<{uid:string;token:string}>;forget():Promise<void>}>('FinFlowDeviceSession');
let epoch=0;
let restoring=false;
const native=()=>['ios','android'].includes(Capacitor.getPlatform());
export const deviceSessionStatus=()=>native()?vault.status():Promise.resolve({enrolled:false as boolean,uid:undefined as string|undefined});
export async function forgetDeviceSession(){epoch++;if(native())await vault.forget();}
export function cancelDeviceRestoration(){epoch++;}
export function deviceReturnCanceled(error:unknown){
 return /cancel|canceled|cancelled/i.test(error instanceof Error?error.message:String(error||''));
}
export async function keepDeviceSession(user:User){
 if(!native()||!user?.uid)return;
 const status=await deviceSessionStatus();
 if(status.enrolled&&status.uid&&status.uid!==user.uid)await forgetDeviceSession();
 else if(status.enrolled)return;
 try{await enrollDeviceSession(user);}catch{/* Returning Face ID is optional. This sign-in still succeeded. */}
}
async function exchange(idToken:string){
 const response=await fetch(buildApiUrl('/auth/device-session/check'),{method:'POST',headers:{Authorization:`Bearer ${idToken}`,'Content-Type':'application/json'},body:'{}',cache:'no-store'});
 const data=await response.json();
 if(!response.ok||data.ready!==true||typeof data.uid!=='string')throw new Error(response.status===401?'Sign in normally to enable device sign-in again.':'Device sign-in is temporarily unavailable. Try again or sign in normally.');
 return data as {ready:boolean;uid:string};
}
export async function enrollDeviceSession(user:User){
 const generation=epoch;
 // Verify identity and matching backend before storing anything. Signing permission
 // is checked separately during deployment acceptance.
 const result=await exchange(await user.getIdToken(true));
 if(generation!==epoch||result.uid!==user.uid||!user.refreshToken)throw new Error('Sign-in changed. Try again.');
 await vault.enroll({uid:user.uid,refreshToken:user.refreshToken});
 if(generation!==epoch){await vault.forget();throw new Error('Sign-in changed.');}
}
export async function restoreDeviceSession(auth:Auth){
 if(restoring||auth.currentUser)throw new Error('A sign-in is already active.');
 restoring=true;const generation=epoch;
 try{
  const renewed=await vault.restore();
  if(generation!==epoch||auth.currentUser)throw new Error('Sign-in changed.');
  if(typeof renewed.token!=='string'||!renewed.uid)throw new Error('Device sign-in response was invalid.');
  const signed=await signInWithCustomToken(auth,renewed.token);
  if(generation!==epoch||signed.user.uid!==renewed.uid){if(auth.currentUser===signed.user)await signOut(auth);throw new Error('Sign-in changed.');}
  return signed;
 }finally{restoring=false;}
}
